import { DeleteCaseRequest, DeleteCaseResponse } from '../deletecase';
import * as _m0 from "protobufjs/minimal";
import { withAuthRetry } from '../utils/authRetry';

export async function deleteCase(
    request: DeleteCaseRequest,
    accessToken: string,
    setAccessToken: (token: string | null) => void,
    logout: () => void
): Promise<DeleteCaseResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const encodedRequest = DeleteCaseRequest.encode(request).finish();
        const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

        const params = new URLSearchParams(window.location.search);
        const staging = params.get('stagingEnv')?.toLowerCase() === 'true';

        let url = "https://rnmjoi8ycf.execute-api.us-west-2.amazonaws.com/adminservice/deletecase";
        if (staging) {
            url = `${url}-staging`;
        }

        const response = await fetch(
            url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: base64
        }
        );
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): DeleteCaseResponse => {
        return DeleteCaseResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}
